var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.505 6.76514H4.50504C3.26239 6.76514 2.25504 7.7725 2.25504 9.01514V18.0151C2.25504 19.2578 3.26239 20.2651 4.50504 20.2651H19.505C20.7477 20.2651 21.755 19.2578 21.755 18.0151V9.01514C21.755 7.7725 20.7477 6.76514 19.505 6.76514Z",
    stroke: "#34393E",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.505 6.76514H4.50504C3.26239 6.76514 2.25504 7.7725 2.25504 9.01514V18.0151C2.25504 19.2578 3.26239 20.2651 4.50504 20.2651H19.505C20.7477 20.2651 21.755 19.2578 21.755 18.0151V9.01514C21.755 7.7725 20.7477 6.76514 19.505 6.76514Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.505 6.76514H4.50504C3.26239 6.76514 2.25504 7.7725 2.25504 9.01514V18.0151C2.25504 19.2578 3.26239 20.2651 4.50504 20.2651H19.505C20.7477 20.2651 21.755 19.2578 21.755 18.0151V9.01514C21.755 7.7725 20.7477 6.76514 19.505 6.76514Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2825 6.74998V5.34373C19.2824 4.99883 19.2062 4.6582 19.0592 4.34615C18.9123 4.0341 18.6984 3.75832 18.4326 3.53849C18.1668 3.31866 17.8558 3.16019 17.5217 3.0744C17.1877 2.98861 16.8388 2.9776 16.5 3.04217L4.155 5.1492C3.6189 5.25136 3.13526 5.53741 2.78749 5.958C2.43972 6.37859 2.24963 6.90736 2.25 7.4531V9.74998",
    stroke: "#34393E",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2825 6.74998V5.34373C19.2824 4.99883 19.2062 4.6582 19.0592 4.34615C18.9123 4.0341 18.6984 3.75832 18.4326 3.53849C18.1668 3.31866 17.8558 3.16019 17.5217 3.0744C17.1877 2.98861 16.8388 2.9776 16.5 3.04217L4.155 5.1492C3.6189 5.25136 3.13526 5.53741 2.78749 5.958C2.43972 6.37859 2.24963 6.90736 2.25 7.4531V9.74998",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2825 6.74998V5.34373C19.2824 4.99883 19.2062 4.6582 19.0592 4.34615C18.9123 4.0341 18.6984 3.75832 18.4326 3.53849C18.1668 3.31866 17.8558 3.16019 17.5217 3.0744C17.1877 2.98861 16.8388 2.9776 16.5 3.04217L4.155 5.1492C3.6189 5.25136 3.13526 5.53741 2.78749 5.958C2.43972 6.37859 2.24963 6.90736 2.25 7.4531V9.74998",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14C17.8022 14 17.6089 13.9414 17.4444 13.8315C17.28 13.7216 17.1518 13.5654 17.0761 13.3827C17.0004 13.2 16.9806 12.9989 17.0192 12.8049C17.0578 12.6109 17.153 12.4327 17.2929 12.2929C17.4327 12.153 17.6109 12.0578 17.8049 12.0192C17.9989 11.9806 18.2 12.0004 18.3827 12.0761C18.5654 12.1518 18.7216 12.28 18.8315 12.4444C18.9414 12.6089 19 12.8022 19 13C19 13.2652 18.8946 13.5196 18.7071 13.7071C18.5196 13.8946 18.2652 14 18 14Z",
    fill: "#34393E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14C17.8022 14 17.6089 13.9414 17.4444 13.8315C17.28 13.7216 17.1518 13.5654 17.0761 13.3827C17.0004 13.2 16.9806 12.9989 17.0192 12.8049C17.0578 12.6109 17.153 12.4327 17.2929 12.2929C17.4327 12.153 17.6109 12.0578 17.8049 12.0192C17.9989 11.9806 18.2 12.0004 18.3827 12.0761C18.5654 12.1518 18.7216 12.28 18.8315 12.4444C18.9414 12.6089 19 12.8022 19 13C19 13.2652 18.8946 13.5196 18.7071 13.7071C18.5196 13.8946 18.2652 14 18 14Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14C17.8022 14 17.6089 13.9414 17.4444 13.8315C17.28 13.7216 17.1518 13.5654 17.0761 13.3827C17.0004 13.2 16.9806 12.9989 17.0192 12.8049C17.0578 12.6109 17.153 12.4327 17.2929 12.2929C17.4327 12.153 17.6109 12.0578 17.8049 12.0192C17.9989 11.9806 18.2 12.0004 18.3827 12.0761C18.5654 12.1518 18.7216 12.28 18.8315 12.4444C18.9414 12.6089 19 12.8022 19 13C19 13.2652 18.8946 13.5196 18.7071 13.7071C18.5196 13.8946 18.2652 14 18 14Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.13320c52dc9ccedef5157c3a9e99f4a8.svg";
export { ForwardRef as ReactComponent };